import { type Qualification } from "./getQualificationsForWorkplaceType";

export function getQualificationDisplayLabel(
  workerType: string,
  qualifications?: Qualification[]
): string {
  const qualification = qualifications?.find((q) => q.name === workerType);
  return qualification?.displayLabel ?? workerType;
}
